/*
import { Grupo } from "./models"

export default {
  grupos: [] as Grupo[],
  loading: false,
}
*/

import { Grupo } from "./models"

export default class GruposState {
  grupos: Grupo[] = []
  loading: boolean = false
}